<template>
  <div class="customer-list salaryCalculationDetail clearfix"
       style="display: flex">
    <div style="background-color: #fff">
      <goBack />
      <div style="background-color: #f5f7fa; margin: 16px; font-size: 14px">
        <div style="
            text-align: center;
            padding: 15px;
            background-color: #409eff;
            color: #fff;
            border-radius: 5px 5px 0 0;
          ">
          工资条计算进度
        </div>
        <div class="leftStep">
          <el-steps direction="vertical"
                    :active="NumMatch(detail.calculateState)"
                    finish-status="success">
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                <span style="text-decoration: underline; cursor: pointer"
                      @click="$router.push('/salaryCalculationList')">上传</span>
                <span>{{
                  detail.createDate && detail.createDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>上传人员：{{ detail.createUserName }}</div>
              </div>
            </el-step>
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                校验
                <span>{{
                  detail.reviewDate && detail.reviewDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>校验人员：{{ detail.reviewUserName }}</div>
              </div>
            </el-step>
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                计算
                <span>{{
                  detail.calculateDate && detail.calculateDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>计算人员：{{ detail.calculateUserName }}</div>
              </div>
            </el-step>
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                生成
                <span>{{
                  detail.generateDate && detail.generateDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>生成人员：{{ detail.generateUserName }}</div>
              </div>
            </el-step>
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                核对
                <span>{{
                  detail.checkDate && detail.checkDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>核对人员：{{ detail.checkUserName }}</div>
              </div>
            </el-step>
            <el-step>
              <div slot="title"
                   style="display: flex; justify-content: space-between">
                发布
                <span>{{
                  detail.releaseDate && detail.releaseDate.slice(0, 10)
                }}</span>
              </div>
              <div slot="description"
                   style="margin-top: 10px">
                <div>发布人员：{{ detail.releaseUserName }}</div>
              </div>
            </el-step>
          </el-steps>
        </div>
      </div>
    </div>
    <div class="customer-table-list fr page heightPage"
         v-loading="submitLoading">
      <Search @getHeight="getHeight"
              @saveSet="saveSet"
              :isquery="false"
              width="310px"
              :tableConfig="tableConfig"
              :advancedQuery="false"
              :isSort="false"
              :key="888"
              @add="addSalary"
              :showAdd="detail.calculateState == 1"
              :showDel="detail.calculateState == 4"
              :functionBtn="true"
              :delPara="delPara"
              ref="Search"
              :bodyScaleFlag="true"
              :showSort="false"
              searchName="salaryCalculationDetail">
        <template v-slot:left>
          <el-col :lg="24"
                  :md="24"
                  :sm="24"
                  :xs="24">
            <el-form-item label="关键字">
              <el-input v-model="searchForm.keyWord"
                        clearable
                        @keyup.enter.native="$refs.Search.handleSearch"
                        placeholder="请输入关键字查询"></el-input>
            </el-form-item>
          </el-col>
        </template>
        <template v-slot:center>
          <el-button size="small "
                     type="success"
                     icon="el-icon-edit"
                     plain
                     :loading="submitLoading"
                     v-if="detail.calculateState == 4 && verifyPermission('Update')"
                     @click="saveData">保存</el-button>
          <el-button size="small "
                     type="success"
                     icon="el-icon-edit"
                     plain
                     v-if="detail.calculateState == 4 && verifyPermission('Update')"
                     @click="atchModify">批改</el-button>
          <!-- <el-button
            size="small "
            type="success"
            icon="el-icon-edit"
            plain
            :loading="submitLoading"
            v-if="detail.calculateState == 4 && verifyPermission('Update')"
            @click="calculation"
            >工资计算</el-button
          > -->
          <el-button size="small "
                     type="success"
                     icon="el-icon-back"
                     plain
                     :loading="submitLoading"
                     @click="back"
                     v-if="detail.calculateState != 4 && verifyPermission('Update')">退回重算</el-button>
          <div class="countRadio"
               v-if="detail.calculateState == 4">
            <el-radio-group v-model="radio"
                            text-color="#67C23A">
              <el-radio :label="true">计算</el-radio>
              <el-radio :label="false">不计算</el-radio>
            </el-radio-group>
          </div>

          <el-dropdown style="margin: 0 10px"
                       trigger="hover"
                       v-if="
              detail.calculateState == 4 && verifyPermission('Update') && radio
            "
                       @command="handleCommand">
            <el-button type="success"
                       size="small"
                       plain>
              下一步<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown"
                              class="lang-select-dropdown"
                              :append-to-body="false">
              <el-dropdown-item icon="el-icon-edit"
                                command="staff">员工计算</el-dropdown-item>
              <el-dropdown-item icon="el-icon-edit"
                                command="foreman">工头计算</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button size="small "
                     type="success"
                     icon="el-icon-check"
                     plain
                     :loading="submitLoading"
                     @click="generate"
                     v-if="detail.calculateState && verifyPermission('Update') && !radio">下一步</el-button>
          <!-- <el-button
            size="small "
            type="success"
            icon="el-icon-document-checked"
            plain
            v-if="detail.calculateState == 2 && verifyPermission('Update')"
            @click="checkData"
            >核对数据</el-button
          > -->
        </template>
      </Search>
      <div style="margin-top: 10px">
        <div style="text-align: center">项目名称:{{ detail.projectName }}</div>
      </div>
      <MyTable class="mytable"
               :tableData="tableData"
               :tableConfig="tableConfig"
               @selectionChange="handleSelectionChange"
               :height="tableHeight"
               :tableType="detail.calculateState == 4 ? 'selection' : ''">
        <!-- <template v-slot:index="slotData" v-if="indexFlag">
          <span>
            {{ slotData.scope.$index + 1 }}
          </span>
        </template> -->

        <template v-for="item in tableConfig"
                  v-slot:[item.slotName]="slotData">
          <div :key="item.field"
               v-if="detail.calculateState == 2">
            {{ slotData.scope.row[item.field] }}
          </div>
          <el-input v-if="detail.calculateState != 2"
                    :key="item.field"
                    v-model="slotData.scope.row[item.field]"
                    @change="slotData.scope.row.change = '1'"></el-input>
          <!-- <el-input
            :key="item.id"
            v-model="slotData.scope.row[item.field]"
            oninput="value=value.replace(/[^0-9.]/g,'')"
            @blur="slotData.scope.row[item.field] = $event.target.value"
          ></el-input> -->
        </template>

        <template v-slot:moreOperation="slotData">
          <el-button @click="save(slotData.scope.row)"
                     size="small"
                     type="primary"
                     plain
                     icon="el-icon-edit">保存</el-button>
          <!-- <el-button
            @click="deleteData(slotData.scope.row.id)"
            type="danger"
            plain
            size="small"
            icon="el-icon-delete"
            >删除</el-button
          > -->
        </template>
      </MyTable>

      <el-dialog title="批量修改"
                 :visible.sync="batchVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px">
        <el-form ref="inputForm"
                 :model="inputForm"
                 :rules="rules"
                 label-width="auto"
                 v-enterToNext="true">
          <el-form-item label="表头名称"
                        prop="headerName">
            <el-select v-model="inputForm.headerName"
                       placeholder="请选择需要修改表头名称"
                       filterable
                       ref="batchSelect">
              <el-option v-for="item in tableConfig"
                         :key="item.field"
                         :label="item.label"
                         :value="item.field">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改后的值">
            <el-input style="width: 64%"
                      v-model="inputForm.value"
                      placeholder="请输入修改后的值"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                (inputForm = {}), (batchVisible = false);
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="batchModify('inputForm')">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="新增工资条"
                 :visible.sync="addStripVisible"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="440px">
        <el-form ref="StripForm"
                 :model="StripForm"
                 :rules="rules"
                 label-width="auto"
                 v-enterToNext="true">
          <el-form-item label="工资条名称"
                        prop="name">
            <el-input style="width: 64%"
                      v-model="StripForm.name"
                      placeholder="请输入工资条名称"
                      maxlength="5"></el-input>
          </el-form-item>
          <el-form-item label="工资条标题"
                        prop="title">
            <el-input style="width: 64%"
                      v-model="StripForm.title"
                      placeholder="请输入工资条标题"
                      maxlength="25"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="
              () => {
                (StripForm = {}), (addStripVisible = false);
              }
            ">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="OneKeyGenerateSalaryHeader('StripForm')">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="AI计算公式自动识别"
                 :visible.sync="mateResult"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="60%"
                 center
                 @close="allFlag = false">
        <div class="table">
          <div class="title">
            <span class="num"><i class="el-icon-info"></i></span>
            <span class="tip">提示：点击查看所有匹配项或进行手动改动！</span>
            <span style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
                margin-left: 10px;
              "
                  v-if="!allFlag"
                  @click="
                (allFlag = true),
                  (mateTableData = mateTableData.concat(headerMatchList))
              ">全部</span>
          </div>

          <MyTable class="mytable"
                   :tableData="mateTableData"
                   :tableConfig="mateTableConfig"
                   height="400px"
                   :indexFlag="true">
            <template v-slot:index="slotData">
              <span>
                {{ slotData.scope.$index + 1 }}
              </span>
            </template>

            <template v-slot:isNeedCalculate="slotData">
              <span>
                {{ slotData.scope.row.isNeedCalculate ? "是" : "否" }}
              </span>
            </template>
            <template v-slot:standardFile="slotData">
              <el-select v-model="slotData.scope.row.standardFile"
                         placeholder="请选择对应的表头"
                         filterable
                         clearable
                         size="small"
                         ref="batchSelect"
                         @change="selectStandardFile($event, slotData.scope.row)">
                <el-option v-for="item in SalaryHeaderSetList"
                           :key="item.field"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </template>
            <template v-slot:property="slotData">
              <el-select v-model="slotData.scope.row.property"
                         placeholder="请选择计算方式"
                         filterable
                         clearable
                         size="small"
                         :disabled="true"
                         ref="batchSelect"
                         @change="changeProperty($event, slotData.scope.row)"
                         @clear="slotData.scope.row.isNeedCalculate = false">
                <el-option v-for="item in propertyList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </template>
            <template v-slot:remark="slotData">
              <el-input v-model="slotData.scope.row.remark"
                        placeholder="请输入说明"></el-input>
            </template>
          </MyTable>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="mateResult = false">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="conMatch()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="提示"
                 :visible.sync="genMateResult"
                 :close-on-click-modal="false"
                 :close-on-press-escape="false"
                 width="550px"
                 center
                 @close="allFlag = false">
        <div class="table">
          <div class="title">
            <span class="num"><i class="el-icon-info"></i></span>
            <span class="tip">此页面用于确认和匹配导入工资条的表头！ </span>
            <span style="
                text-decoration: underline;
                cursor: pointer;
                color: #409eff;
              "
                  v-if="!allFlag"
                  @click="(generateData = allHeaderMatchList), (allFlag = true)">全部</span>
          </div>

          <div class="result">
            <div>
              <MyTable class="mytable"
                       :tableData="generateData"
                       :tableConfig="generateTableConfig"
                       height="400px"
                       :indexFlag="true">
                <template v-slot:index="slotData">
                  <span>
                    {{ slotData.scope.$index + 1 }}
                  </span>
                </template>
                <template v-slot:standardFile="slotData">
                  <el-select v-model="slotData.scope.row.standardFile"
                             placeholder="请选择对应的表头"
                             filterable
                             clearable
                             ref="batchSelect">
                    <el-option v-for="item in SalaryHeaderSetList"
                               :key="item.field"
                               :label="item.name"
                               :value="item.name">
                    </el-option>
                  </el-select>
                </template>
              </MyTable>
            </div>
          </div>
        </div>
        <span slot="footer"
              class="dialog-footer">
          <el-button size="small "
                     :loading="submitLoading"
                     @click="genMateResult = false">关 闭</el-button>
          <el-button size="small "
                     type="primary"
                     :loading="submitLoading"
                     @click="conMatching">确 定</el-button>
        </span>
      </el-dialog>
      <salaryVerification :visible="salaryVerificationVisible"
                          :salaryId="this.$route.query.id"
                          @close="salaryVerificationVisible = false"></salaryVerification>

      <!-- <Pagination
        class="PagPosition"
        :total="total"
        @getNewData="salaryCalculationDetail"
        ref="pagination"
      /> -->
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import MyTable from "@/components/Table";
import store from "@/store/index";
import goBack from "@/components/goBack";
import salaryVerification from "./salaryVerification.vue";
import { verifyPermissionMinix } from "@/utils/mixin";
export default {
  components: {
    Search,
    MyTable,
    salaryVerification,
    goBack
  },
  mixins: [verifyPermissionMinix],
  data () {
    return {
      tableName: "salaryCalculationDetail",
      tableConfig: [],
      generateTableConfig: [
        {
          field: "file",
          label: "导入工资条表头",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "standardFile",
          label: "匹配值",
          align: "center",
          slotName: "standardFile",
          flag: true,
          minWidth: 100,
        },
      ],
      mateTableConfig: [
        {
          field: "file",
          label: "原表头",
          align: "center",
          flag: true,
          minWidth: 100,
        },
        {
          field: "isNeedCalculate",
          label: "需要计算",
          align: "center",
          slotName: "isNeedCalculate",
          flag: true,
          width: 100,
        },
        {
          field: "standardFile",
          label: "匹配后表头",
          align: "center",
          slotName: "standardFile",
          flag: true,
          minWidth: 100,
        },
        {
          field: "property",
          label: "计算方式",
          align: "center",
          slotName: "property",
          flag: true,
          minWidth: 100,
        },
        // {
        //   field: "correlationFile",
        //   label: "关联字段",
        //   align: "center",
        //   flag: true,
        //   minWidth: 100,
        // },
        {
          field: "remark",
          label: "说明",
          align: "center",
          slotName: "remark",
          flag: true,
          minWidth: 100,
        },
      ],
      propertyList: [
        { label: "加", value: "+" },
        { label: "减", value: "-" },
        { label: "乘", value: "*" },
        { label: "除", value: "/" },
        // { label: "结果项", value: "=" },
      ],
      form: {},
      inputForm: {},
      tableHeight: "",
      radio: false,
      salaryVerificationVisible: false,
      selectloading: false,
      submitLoading: false,
      importVisible: false,
      userForm: {},
      mateResult: false,
      companyList: [],
      Ids: [],
      currentRow: null,
      searchList: [],
      total: 0,
      loading: false,
      headerMatchList: [],
      allHeaderMatchList: [],
      headerNotMatchList: [],
      tableData: [],
      tableConfig2: [],
      allFlag: false,
      addStripVisible: false,
      StripForm: {},
      searchForm: {},
      mateArr: [],
      indexFlag: true,
      batchVisible: false,
      customerIds: [],
      MatchList: [],
      tableData2: [],
      rules: {
        headerName: [
          { required: true, message: "请选择表头名称", trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入工资条名称", trigger: "blur" },
        ],
        title: [
          { required: true, message: "请选择工资条标题", trigger: "blur" },
        ],
      },
      headerList: [],
      calculateType: "",
      mateTableData: [],
      generateData: [],
      SalaryHeaderSetList: [],
      genMateResult: false,
      sendFlag: false,
      operation: "",
      companyId: "",
      detail: "",
      delPara: {
        data: "",
        controller: "salary",
        action: "SalaryOriginalDataDelete",
        callback: "salaryCalculationDetail",
      },
    };
  },
  mounted () {
    this.SalaryCalculateMainDetail();
    // this.SalaryHeaderSetMatchList();
    this.payRollList();
    //初始化设置列的隐藏和排序方法
    const tab = {
      path: "/salaryCalculationList",
      title: "工资计算",
    };
    store.commit("addTab", tab);
    if (localStorage.getItem(this.tableName)) {
      this.tableConfig = JSON.parse(localStorage.getItem(this.tableName));
      this.sortType = this.tableConfig.pop();
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = this.sortType;
        }
      });
    }
  },
  methods: {
    handleCommand (command) {
      if (command == "staff") {
        this.calculateType = 1;
        this.calculation();
      } else {
        this.calculateType = 2;
        this.calculation();
      }
      console.log(command);
    },
    changeProperty (v, row) {
      if (v) {
        row.isNeedCalculate = true;
      } else {
        row.isNeedCalculate = false;
      }
    },
    //改变状态值
    NumMatch (val) {
      switch (val) {
        case 1:
          return 1;
        case 2:
          return 3;
        case 3:
          return 4;
        case 4:
          return 2;
        case 5:
          return 5;
        default:
          break;
      }
    },
    SalaryHeaderList () {
      let sendData = {
        mainId: this.detail.salaryHeaderMainId,
      };
      this.$api.salary.SalaryHeaderList(sendData).then((res) => {
        if (res.error === false) {
          this.SalaryHeaderSetMatchList(res.data);
          // console.log(111, res.data);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    OneKeyGenerateSalaryHeader (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.mateArr);
          this.submitLoading = true;
          let sendData = {
            name: this.StripForm.name,
            title: this.StripForm.title,
            salaryHeaderSetMatchList: this.mateArr,
            salaryId: this.$route.query.id,
          };
          this.$api.salary.OneKeyGenerateSalaryHeader(sendData).then((res) => {
            this.submitLoading = false;

            if (res.error === false) {
              this.addStripVisible = false;
              this.StripForm = {};
              this.mateResult = false;
              this.confirmCalculation();

            } else {
              let str = "";

              res.data.forEach((item) => {
                if (item.originalValue == item.standardValue) {
                  str =
                    str +
                    '<div style="margin-top:8px">' +
                    item.standardValue +
                    "已被" +
                    item.originalValue +
                    "使用，请勿重复使用</div>";
                }
              });
              this.$message.error({
                dangerouslyUseHTMLString: true,
                message: str,
              });
              // this.$message.error(str);
            }
          });
        }
      });
    },

    // 获取工资表头匹配字段
    SalaryHeaderSetMatchList (parArr) {
      console.log(5555);
      let sendData = {
        mainId: this.detail.salaryHeaderMainId,
      };
      this.$api.salary.SalaryHeaderSetMatchList(sendData).then((res) => {
        if (res.error === false) {
          parArr.forEach((element) => {
            res.data.forEach((item) => {
              delete item.id;
              delete item.salaryHeaderMainId;
              if (element.name && element.name.trim() == item.originalValue) {
                console.log(2);
                item.field = element.field;
                item.sort = element.sort;
                return;
              }
            });
          });

          this.MatchList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    batchModify (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.tableData.forEach((item, i) => {
            item[this.inputForm.headerName] = this.inputForm.value;
            item.change = "1";
          });
          this.inputForm = {};
          this.batchVisible = false;
          this.saveData(true);
        }
      });
    },
    atchModify () {
      this.batchVisible = true;
    },
    conMatch () {
      let sendData = {
        salaryId: this.detail.id,
        formattingHeaderMatchList: this.mateTableData,
        calculateType: this.calculateType,
      };
      if (this.sendFlag && !this.allFlag) {
        sendData.formattingHeaderMatchList = this.mateTableData.concat(
          this.headerMatchList
        );
      }
      this.submitLoading = true;
      this.$api.salary.SmartMatchSalaryCalculate(sendData).then((res) => {
        this.submitLoading = false;
        if (res.error === false) {
          this.radio = false;
          this.$message.success("计算成功");
          this.SalaryCalculateMainDetail();
          this.allFlag = false;

          this.mateResult = false;
        } else if (res.code == 1) {
          this.$message.warning(res.msg);
          this.allFlag = true;
          this.mateTableData = this.allHeaderMatchList;
          this.mateResult = true;
        } else {
          this.$message.error(res.msg);
        }
      });
      // let mateArr = [];
      // let tableData2 = JSON.parse(JSON.stringify(this.tableData2));
      // for (var i = 0; i < tableData2.length; i++) {
      //   if (!tableData2[i].obj) {
      //     this.$message.warning("请您进行全部匹配");
      //     return;
      //   } else {
      //     this.$set(
      //       tableData2[i].obj,
      //       "originalValue",
      //       tableData2[i].fieldName
      //     );

      //     mateArr.push(JSON.parse(JSON.stringify(tableData2[i].obj)));
      //     // console.log(this.tableData2[i].fieldName);
      //   }
      // }
      // let myMatchList = JSON.parse(JSON.stringify(this.MatchList));
      // mateArr.forEach((element) => {
      //   myMatchList.forEach((value, i) => {
      //     if (element.standardValue == value.standardValue) {
      //       myMatchList.splice(i, 1);
      //     }
      //   });
      // });
      // this.mateArr = mateArr.concat(myMatchList);
      // this.$forceUpdate();
      // this.addStripVisible = true;
      // this.mateResult = false;
      // this.SalaryCalculateMainDetail();
    },
    addSalary () {
      this.$confirm(
        "新增前请您检查是否编辑过数据，如编辑请先保存后再新增，否则编辑无效！",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认新增",
          cancelButtonText: "保存",
        }
      )
        .then(() => {
          let sendData = {
            salaryId: this.tableConfig2.salaryId,
            companyId: this.tableConfig2.companyId,
          };
          this.$api.salary.SalaryOriginalDataEdit(sendData).then((res) => {
            if (res.error === false) {

              this.salaryCalculationDetail();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch((action) => {
          if (action == "cancel") {
            this.saveData();
          }
        });
    },
    // 核对数据
    checkData () {
      this.salaryVerificationVisible = true;
    },
    back () {
      this.$confirm("是否确认回退并重新计算？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const formData = new FormData();
          formData.append("salaryId", this.$route.query.id);
          this.$api.salary.RollBackCalculateData(formData).then((res) => {

            if (res.error === false) {
              this.SalaryCalculateMainDetail();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },
    // 保存数据
    async saveData (flag) {
      let sendData = [];
      this.loading = true;
      this.tableData.forEach((item) => {
        if (item.change == "1") {
          item.autoInt = undefined;
          sendData.push(item);
          // sendData = item;
        }
      });
      this.submitLoading = true;
      await this.$api.salary
        .SalaryOriginalDataBatchEdit(sendData)
        .then((res) => {
          this.loading = false;
          this.submitLoading = false;

          if (res.error === false) {
            if (flag != true) {
              this.$message.success("保存成功");
            }

          } else {
            this.$message.error(res.msg);
          }
        });
    },
    // 获取主页详情
    SalaryCalculateMainDetail () {
      let sendData = {
        id: this.$route.query.id,
        keyWord: this.searchForm.keyWord,
      };
      this.$api.salary.SalaryCalculateMainDetail(sendData).then((res) => {
        if (res.error === false) {
          this.detail = res.data;
          this.SalaryHeaderList();
          this.salaryCalculationDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    importExport () { },
    // 通知开卡
    notifyCard () {
      this.personnelTip();

      // this.notifyCardShow = true;
    },
    save (value) {
      this.$api.salary.SalaryDetailEdit(value).then((res) => {
        if (res.error === false) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    clearSearchList () {
      this.searchList = [];
    },

    resetUserForm () {
      this.userForm = {};
      this.$refs.userForm.clearValidate();
    },

    //获取列的隐藏数据
    saveSet (checkList, type) {
      if (checkList) {
        this.tableConfig = JSON.parse(JSON.stringify(checkList));
      }
      this.sortType = type;
      this.tableConfig.forEach((element) => {
        if (element.sortable) {
          element.sortable = type;
        }
      });
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
      this.delPara.data = selection.map((v) => {
        return v.id;
      });
    },
    //计算表格高度
    getHeight (height) {
      let newHeight = height.replace("px", "");
      this.tableHeight = newHeight - 90 + "px";
    },
    clear () {
      console.log(0);
      this.searchForm.isCooperation = undefined;
    },
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        // console.log(res);
        if (res.error === false) {
          this.companyList = res.data;
        }
      });
    },
    // 重新处理对象
    objectOrder (obj) {
      //排序的函数

      var newkey = Object.keys(obj).sort(); //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组，这行是最重要的代码！

      var newObj = {}; //创建一个新的对象，用于存放排好序的键值对

      for (var i = 0; i < newkey.length; i++) {
        //遍历newkey数组

        newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
      }

      return newObj; //返回排好序的新对象
    },
    //获取数据
    salaryCalculationDetail () {
      this.loading = true;
      let Data = "";
      let sendData = {};
      sendData = {
        pageIndex: 1,
        pageSize: 99999,
        salaryId: this.$route.query.id,
        keyWord: this.searchForm.keyWord,
      };
      this.$api.salary[
        this.detail.calculateState == 4
          ? "OriginalDatePage"
          : this.detail.calculateState == 2
            ? "SalaryOriginalCalculateInfoPage"
            : "SubstitutePayPage"
      ](sendData).then((res) => {
        if (!res.error) {

          this.tableConfig = [];
          if (this.detail.calculateState == 4) {
            this.tableConfig2 = res.data.salaryOriginalHeaderModel;
            for (var i in this.objectOrder(
              res.data.salaryOriginalHeaderModel
            )) {
              if (
                i.indexOf("cell") != -1 &&
                res.data.salaryOriginalHeaderModel[i] != null
              ) {
                if (res.data.salaryOriginalHeaderModel[i] == "序号") {
                  this.indexFlag = false;
                }
                // console.log(res.data.salaryOriginalHeaderModel[i]);

                this.tableConfig.push({
                  field: i,
                  label: res.data.salaryOriginalHeaderModel[i],
                  minWidth: "120",
                  align: "center",
                  slotName: res.data.salaryOriginalHeaderModel[i],
                  flag: true,
                });
              }
            }
            this.tableData = res.data.salaryOriginalDatumPage.data;
            this.total = res.data.salaryOriginalDatumPage.count;
          } else {
            for (var i in this.objectOrder(
              res.data.salaryCalculateHeaderModel
            )) {
              if (
                i.indexOf("cell") != -1 &&
                res.data.salaryCalculateHeaderModel[i] != null
              ) {
                if (res.data.salaryCalculateHeaderModel[i] == "序号") {
                  this.indexFlag = false;
                }
                this.tableConfig.push({
                  field: i,
                  label: res.data.salaryCalculateHeaderModel[i],
                  minWidth: "120",
                  align: "center",
                  slotName: res.data.salaryCalculateHeaderModel[i],
                  flag: true,
                });
              }
            }
            this.tableConfig.push(
              {
                field: "shouldSalary",
                label: "应发工资",
                minWidth: "120",
                align: "center",
                flag: true,
              },
              {
                field: "netPayroll",
                label: "实发工资",
                minWidth: "120",
                align: "center",
                flag: true,
              }
            );
            this.tableData = res.data.salaryCalculateDatumPage.data;
            this.total = res.data.salaryCalculateDatumPage.count;
          }

          this.loading = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    // 添加客户
    addCustomer () {
      this.operation = "add";
      this.addCustomerDrawerShow = true;
      this.drawerTitle = "新增公司";
    },
    // 通知开卡
    personnelTip () {
      this.$confirm("暂无人员数据,请前往人员管理处添加人员!", "提示", {
        confirmButtonText: "前往人员管理",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.$api.customer.deleteFactory(ids).then((res) => {
          // 
          //   if (res.error === false) {
          //     this.salaryCalculationDetail();
          //     this.getCustomerLevelClassData();
          //   }
          // });
        })
        .catch(() => { });
    },
    payRollList () {
      this.$api.salary.SalaryHeaderSetList().then((res) => {
        if (res.error === false) {
          this.SalaryHeaderSetList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //工资计算
    calculation () {
      this.sendFlag = false;

      let sendData = {
        salaryId: this.detail.id,
      };
      this.submitLoading = true;
      this.$api.salary.FormattingHeaderMatch(sendData).then((res) => {
        this.submitLoading = false;
        if (res.code == 0) {
          this.allHeaderMatchList = res.data.allHeaderMatchList;
          this.headerNotMatchList = res.data.headerNotMatchList;
          this.headerMatchList = res.data.headerMatchList;
          if (res.data.isAllMatch) {
            this.$confirm(
              "AI已全部智能匹配，可点击查看进行确认和修改！",
              "提示",
              {
                confirmButtonText: "继续",
                cancelButtonText: "查看",
                type: "warning",
                distinguishCancelAndClose: true,
              }
            )
              .then(() => {
                this.mateTableData = res.data.allHeaderMatchList;
                this.conMatch();
                // this.radio = false;
              })
              .catch((flag) => {
                if (flag == "cancel") {
                  this.allFlag = true;
                  this.mateTableData = res.data.allHeaderMatchList;
                  this.mateResult = true;
                }
              });
          } else {
            this.mateTableData = res.data.headerNotMatchList;
            this.mateResult = true;
            this.sendFlag = true;
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    confirmCalculation () {
      let sendData = {
        salaryId: this.$route.query.id,
      };
      // this.submitLoading = true;
      this.mateResult = true;
      return;
      this.$api.salary.OrignalDataCalculate(sendData).then((res) => {
        if (res.code == 0) {
          this.submitLoading = false;
          this.$message.success("计算成功");
          this.salaryCalculationDetail();
          this.SalaryCalculateMainDetail();
        } else if (res.code == 3) {
          this.mateResult = true;
          this.submitLoading = false;
          this.tableData2 = res.data.mistakeFieldList;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除
    deleteData (id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const formData = new FormData();
          formData.append("id", id);

          this.$api.salary.SalaryDetailDelete(formData).then((res) => {

            if (res.error === false) {
              this.salaryCalculationDetail();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => { });
    },

    //AI自动识别更改基准字段
    selectStandardFile (value, row) {
      if (!value) {
        console.log(111);
        this.$set(row, "property", "");
        this.$set(row, "isNeedCalculate", false);
        return;
      }
      let obj = this.SalaryHeaderSetList.find((item) => {
        return item.name == value;
      });
      this.$set(row, "property", obj.property);
      this.$set(row, "property", obj.property);
      if (!obj.property || obj.property == "=") {
        this.$set(row, "isNeedCalculate", false);
      } else {
        this.$set(row, "isNeedCalculate", true);
      }
      this.$forceUpdate();
    },
    conMatching () {
      this.$api.salary
        .SaveDirectGenerateFormattingHeaderMatch(this.generateData)
        .then((res) => {

          this.submitLoading = false;
          if (res.error === false) {
            this.genMateResult = false;
            this.enterData();
          } else {
            this.$message.error(res.msg);
          }
        });
    },
    async generate () {
      if (this.detail.calculateState == 4) {
        this.submitLoading = true;
        let sendData = {
          salaryId: this.detail.id,
        };
        await this.saveData(true);
        this.$api.salary
          .DirectGenerateFormattingHeaderMatch(sendData)
          .then((res) => {
            this.submitLoading = false;

            if (res.error === false) {
              this.allHeaderMatchList = res.data.allHeaderMatchList;
              this.headerNotMatchList = res.data.headerNotMatchList;

              if (res.data.isAllMatch) {
                this.$confirm(
                  "AI已全部智能匹配，可点击查看进行确认和修改！",
                  "提示",
                  {
                    confirmButtonText: "继续",
                    cancelButtonText: "查看",
                    type: "warning",
                    distinguishCancelAndClose: true,
                  }
                )
                  .then(() => {
                    this.conMatching();
                  })
                  .catch((flag) => {
                    if (flag == "cancel") {
                      this.allFlag = true;
                      this.generateData = res.data.allHeaderMatchList;
                      this.genMateResult = true;
                    }
                  });
              } else {
                this.generateData = res.data.headerNotMatchList;
                this.genMateResult = true;
              }
            } else {
              this.$message.error(res.msg);
            }
          });
      } else {
        this.enterData();
      }
      // this.enterData();
    },
    enterData () {
      this.$prompt("请输入标准工资表标题", "生成标准工资表", {
        inputValue: this.detail.wageTitle,
        inputPattern: /^.+$/,
        inputErrorMessage: "请输入标题",
        confirmButtonText: "确 定",
        cancelButtonText: "关 闭",
        inputPlaceholder: "请输入标准工资表标题",
      })
        .then((value) => {
          this.submitLoading = true;
          let sendData = {
            salaryId: this.$route.query.id,
            title: value.value,
            isSalary: this.detail.calculateState == 2 ? true : false,
          };
          this.$api.salary.FormatterSalaryData(sendData).then((res) => {
            if (res.error === false) {
              this.$router.replace(
                "/salaryCalculationGenerated?id=" + this.detail.id
              );
              this.submitLoading = false;
            } else {
              this.$message.error(res.msg);
              this.submitLoading = false;
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>
<style lang="less" >
.countRadio {
  display: inline-block;
  margin: 0 10px;
  border: 1px solid #c2e7b0;
  padding: 9px 15px;
  border-radius: 3px;
  .el-radio {
    margin-right: 15px;
  }
}
.lang-select-dropdown {
  width: 130px;
}
.customer-list {
  .upload-demo {
    .el-upload {
      width: 100% !important;
    }
    .el-upload-dragger {
      width: 100% !important;
    }
  }
}
.salaryCalculationDetail .mytable {
  .el-input__inner {
    text-align: center !important;
    height: 30px;
    line-height: 30px;
  }
}
</style>
<style lang="less" scoped>
// .el-form-item__label {
//   width: 60px !important;
// }

.btn {
  margin-left: 15px;
}
.customer-list {
  .file,
  .table {
    width: 100%;
    .title {
      display: flex;
      align-items: center;
      .num {
        color: rgb(26, 210, 103);
        font-size: 22px;
        margin-right: 15px;
      }
    }

    .upload-demo {
      width: 100%;
      padding: 10px 70px;
      .el-upload-dragger {
        width: 100% !important;
      }
    }
    .result {
      padding: 10px 70px;
    }
  }

  .category {
    width: 200px;
    height: calc(100vh - 155px);
    background-color: #fff;
    border-radius: 6px;
    padding: 20px;
    margin-right: 20px;
    > div {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 15px;
      img {
        width: 16px;
        margin-right: 5px;
      }
    }
    li {
      margin-top: 12px;
      cursor: pointer;
      &:hover {
        color: var(--theme-black);
        text-decoration: underline;
      }
    }
    .tab-active {
      color: #87481f !important;
      text-decoration: underline !important;
    }
  }
  .customer-table-list {
    width: calc(100%);
    height: calc(100vh - 155px);
  }
}
</style>
